import { useEffect, useState } from 'react';
import { Button, Grid, Paper, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { getSendingOrderById } from 'src/shared/services/sendingService';
import { SendingOrder } from 'src/modules/sending/models/sendingOrder';
import EditIcon from '@mui/icons-material/Edit';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import ConsoleHelper from 'src/shared/functions/consoleHelper';

const createEditRoute = (id?: any) => {
  return `${RoutesEnum.EditSendingOrder}/${id}`;
};

// TODO: Översätt
export const SendingOrderDetails = () => {
  const [, setIsLoading] = useState(true);
  const [sendingOrder, setSendingOrder] = useState<SendingOrder>();
  const { id } = useParams();

  const breakText = (text) => {
    if (typeof text === 'undefined') {
      return '';
    }
    const lines = text.split('\n');
    return lines.map((line) => {
      return (
        <span key={line}>
          {line}
          <br />
        </span>
      );
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      const result = await getSendingOrderById(id);
      ConsoleHelper.log('fetch', result.data);
      setSendingOrder(result.data);
      setIsLoading(false);
    };
    fetchData();
  }, [id]);

  return (
    <GridWrapper>
      <Grid item xs={12} md={4} style={{ display: 'flex' }}>
        <MainContentHeader title='Granska postutskick' />
      </Grid>
      <Grid item xs={12} md={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant='contained' color='primary' href={createEditRoute(sendingOrder?.id).toString()} endIcon={<EditIcon />}>
          Redigera
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 3 }}>
          <GridWrapper>
            <Grid item xs={12}>
              <Typography variant='caption' color='textSecondary' sx={{ fontWeight: 600 }} gutterBottom>
                Beställare
              </Typography>
              <Typography variant='h6' gutterBottom>
                {sendingOrder?.createdByName}
                <br />
                {sendingOrder?.createdByEmail}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='caption' color='textSecondary' sx={{ fontWeight: 600 }} gutterBottom>
                Datum
              </Typography>
              <Typography variant='h6' gutterBottom>
                {sendingOrder?.date_id}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='caption' color='textSecondary' sx={{ fontWeight: 600 }} gutterBottom>
                Typ av utskick
              </Typography>
              <Typography variant='h6' gutterBottom>
                Medlemskap
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='caption' color='textSecondary' sx={{ fontWeight: 600 }} gutterBottom>
                Färg eller svartvit tryck?
              </Typography>
              <Typography variant='h6' gutterBottom>
                Färg
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='caption' color='textSecondary' sx={{ fontWeight: 600 }} gutterBottom>
                Meddelande
              </Typography>
              <Typography variant='subtitle1' gutterBottom>
                {breakText(sendingOrder?.message) || '-'}
              </Typography>
            </Grid>
          </GridWrapper>
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
